import React from 'react';
import { FormattedMessage } from 'react-intl';

import { AnyTransactionPeriod } from '@/model/wallets/types';

interface TransactionFilterTitleLabelProps {
  value: AnyTransactionPeriod;
}

export const TransactionFilterTitleLabel: React.FC<TransactionFilterTitleLabelProps> = ({ value }) => (
  <FormattedMessage id={`demo.pages.transactions.filter.title.label.${value.type}`} />
);
export default React.memo(TransactionFilterTitleLabel);
